import { render, staticRenderFns } from "./fvTable.vue?vue&type=template&id=0f087036&lang=pug&"
import script from "./fvTable.vue?vue&type=script&lang=js&"
export * from "./fvTable.vue?vue&type=script&lang=js&"
import style0 from "./fvTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvTable.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvTable.vue
// module id = 147
// module chunks = 0 1